import { createFileRoute } from '@tanstack/react-router'
import { GPHomePage } from './-components/gp-home-page'

export const Route = createFileRoute('/mrgolisoda/gp-home/')({
  component: GPHomePage,
})
